<template>
  <modal :center="false" :show="visible" modalClasses="modal-xxl">
    <b-row class="sticky-top pt-2 bg-light mt--3 mb-2">
      <b-col sm="12" md="4">
        <b-button class="mb-2" block variant="secondary" @click="handleClose">
          Đóng (Esc)
        </b-button>
      </b-col>
      <b-col sm="12" md="4">
        <b-button block variant="info" @click="doPrint">
          <i class="fa fa-print" aria-hidden="true"></i> In
        </b-button>
      </b-col>
      <b-col sm="12" md="4">
        <b-button
          v-if="showPrice"
          block
          variant="success"
          @click="showPrice = !showPrice"
        >
          <i class="fa fa-eye-slash" aria-hidden="true"></i>
          Ẩn giá
        </b-button>
        <b-button
          v-else
          block
          variant="success"
          @click="showPrice = !showPrice"
        >
          <i class="fa fa-eye" aria-hidden="true"></i>
          Hiển thị giá
        </b-button>
      </b-col>
    </b-row>
    <block ref="bmdal" :nobody="true">
      <div id="print" class="print-box mt-3 mb-3">
        <div class="header text-center">
          <h3>
            CÔNG NỢ : #{{ $date(this.debt.from, "DD/MM/YYYY") }} -
            {{ $date(this.debt.to, "DD/MM/YYYY") }}
          </h3>
        </div>
        <div class="data">
          <b-card
            class="mb-3 m-2"
            no-body
            v-for="(item, index) in debt.data"
            :key="index"
          >
            <b-card-header
              header-tag="header"
              class="p-1 d-flex justify-content-between align-items-center"
            >
              <b-button variant="link" href="#" v-b-toggle="item.key">
                <span>{{ item.month }}</span>
              </b-button>
            </b-card-header>
            <b-collapse visible :id="item.key">
              <b-card-body class="px-2">
                <div
                  class="timeline timeline-one-side"
                  data-timeline-content="axis"
                  data-timeline-axis-style="dashed"
                >
                  <div
                    v-for="(item, index) in item.customers"
                    :key="index"
                    class="timeline-block"
                  >
                    <span class="timeline-step badge-success">
                      <span class="avatar avatar-sm rounded-circle">
                        <!-- <img
                          v-holder="{
                            img: '40x40',
                            text: item.info.name
                          }"
                          @error="$imgHolder"
                          :alt="item.info.name"
                          :src="$mediaURI + item.info.avatar"
                        /> -->
                      </span>
                    </span>
                    <div
                      class="timeline-content"
                      style="width:auto; max-width:unset"
                    >
                      <h5 class="mb-2">
                        {{ item.info.code }} - {{ item.info.name }}
                      </h5>
                      <template v-for="(cur, i) in item.currencys">
                        <div
                          :key="i"
                          style="min-height: 25px; margin-bottom:10px"
                          class="table-responsive base-table table-soft b-table-sticky-header"
                        >
                          <table
                            class="prtable prtable-bordered table tablesorter b-table b-table-no-border-collapse b-table-selectable b-table-select-range b-table-selecting"
                          >
                            <thead>
                              <tr>
                                <th>STT</th>
                                <th>Ngày tạo</th>
                                <th class="text-left">Mã Phiếu xuất</th>
                                <th class="text-left">Người Tạo phiếu</th>
                                <th class="text-right" style="text-align:right">
                                  Tổng tiền
                                </th>
                                <th class="text-right" style="text-align:right">
                                  Đã thanh toán
                                </th>
                                <th class="text-right" style="text-align:right">
                                  Còn lại
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(row, index) in item.data"
                                :key="index"
                              >
                                <template v-if="row.currency == cur.currency">
                                  <td class="bg-info text-light col-fix ">
                                    {{ index + 1 }}
                                  </td>
                                  <td class="text-left">
                                    {{ $dateUnix(row.dateCreated) }}
                                  </td>
                                  <td>{{ row.code }}</td>
                                  <td>
                                    {{ row.userCreated.name }}
                                  </td>
                                  <td
                                    class="text-right"
                                    style="text-align:right"
                                  >
                                    {{ $formatNumber(row.total) }}
                                    {{ cur.currency }}
                                  </td>
                                  <td
                                    class="text-right"
                                    style="text-align:right"
                                  >
                                    {{ $formatNumber(row.paid) }}
                                    {{ cur.currency }}
                                  </td>
                                  <td
                                    class="text-right"
                                    style="text-align:right"
                                  >
                                    {{ $formatNumber(row.total - row.paid) }}
                                    {{ cur.currency }}
                                  </td>
                                </template>
                              </tr>
                            </tbody>
                            <tfoot>
                              <tr>
                                <td colspan="4">Tổng cộng</td>
                                <td class="text-right" style="text-align:right">
                                  {{ $formatNumber(cur.summarry.total) }}
                                  {{ cur.currency }}
                                </td>
                                <td class="text-right" style="text-align:right">
                                  {{ $formatNumber(cur.summarry.paid) }}
                                  {{ cur.currency }}
                                </td>
                                <td class="text-right" style="text-align:right">
                                  {{
                                    $formatNumber(
                                      cur.summarry.total - cur.summarry.paid
                                    )
                                  }}
                                  {{ cur.currency }}
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      </template>
                      <hr style="margin-top:20px" />
                    </div>
                  </div>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
        <div class="footer">
          <table class="prtable">
            <tr>
              <td colspan="2">
                <table class="prtable">
                  <tr>
                    <td style="border-bottom: 1px dotted;">
                      Ghi chú :
                      <p
                        class="print-note"
                        style="display:inline-block; margin:0"
                        v-html="debt.note"
                      ></p>
                    </td>
                  </tr>
                  <tr>
                    <td style="border-bottom: 1px dotted"><br /></td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td class="text-left" style="vertical-align: top; width:50%"></td>
              <td class="text-center" style="vertical-align: top; width:50%">
                <h5>Lập biểu</h5>
                <br />
              </td>
            </tr>
          </table>
        </div>
      </div>
      <event @doCancel="handleClose"></event>
    </block>
  </modal>
</template>
<script>
import { capitalize } from "@/utils/string";
export default {
  props: {},
  data() {
    return {
      visible: false,
      showPrice: true,
      debt: {
        from: "",
        to: "",
        datas: []
      }
    };
  },
  methods: {
    setData(debt) {
      this.debt = debt;

      // productOrders.sort((a, b) => {
      //   if (a.product.name < b.product.name) {
      //     return -1;
      //   }
      //   if (a.product.name > b.product.name) {
      //     return 1;
      //   }
      //   return 0;
      // });
      // productOrders.sort((a, b) => {
      //   if (a.spec.name > b.spec.name) {
      //     return -1;
      //   }
      //   if (a.spec.name < b.spec.name) {
      //     return 1;
      //   }
      //   return 0;
      // });
    },
    checkSameRow(datas, index, compareX, count = 1) {
      let nextIndex = index + 1;
      if (nextIndex >= datas.length) return 1;
      let item = datas[index];
      let nextItem = datas[nextIndex];
      if (compareX(item, nextItem)) {
        count++;
        nextItem.hiden = true;
        return 1 + this.checkSameRow(datas, nextIndex, compareX, count);
      }
      return 1;
    },
    handleClose() {
      this.visible = false;
    },
    doPrint() {
      this.$print("print");
    },
    doSave() {
      this.$refs.bmdal.block();
      this.$emit("doSave", () => {
        this.order.id = true;
        this.$refs.bmdal.unBlock();
      });
    },
    capitalize(s) {
      return capitalize(s);
    }
  }
};
</script>
